import { CustomButton } from '@/Components/CustomButton';
import styles from './index.module.css';
import { ModalComponentV1 } from '@/Components/ModalComponentV1';
import { useContext } from 'react';
import { LanguageContext } from '@/context/languageContext';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const PaymentSystemInfo = ({ isOpen, onClose }: Props) => {
  const { t } = useContext(LanguageContext);

  return (
    <ModalComponentV1
      isOpen={isOpen}
      onClose={onClose}
      title={t('PaymentSystem')}
      className={styles.modal}
    >
      <div
        style={{
          marginTop: 49,
        }}
      >
        <div className={styles.textWrapper}>
          <p>{t('C2cPlatformYouCanPay')}.</p>

          <p>
            {t('PaymentIn')}
            <strong>{t('Tokens')}</strong> {t('DoNotInclude')}
            <strong>{t('CostEffective')}</strong>.
          </p>

          <p>
            {t('ToUseTokens')}
            <strong>{t('TonkeeperAPP')}</strong>
            {t('RentReciveTokens')}.
          </p>

          <p>
            {t('C2cOperateTonBlockchain')}
            <strong>{t('TONBlockchain')}</strong>,{t('TONCoinForProcessing')}.
          </p>

          <p>
            <strong>{t('Issue')}</strong>
            {t('OfTheTokensIsManaged')}
            <strong>{t('algorithmically')}</strong> {t('ReflectingThePlatform')}
            <strong>{t('sustainability')}</strong> {t('OrganicDevelopment')}.
          </p>
        </div>
        <CustomButton
          sizeButton="large"
          typeButton="primary"
          className={styles.btn}
          onClick={onClose}
        >
          <div>{t('Close') || 'Close'}</div>
        </CustomButton>
      </div>
    </ModalComponentV1>
  );
};
